"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("svelte/store");
const utils_1 = require("../shared/utils");
const store_2 = require("../store");
const elementsList = (0, store_1.get)(store_2.elements);
/**
 * Adds a reference to the elements that `scrollTo` should scroll
 *
 * @param reference - The reference element
 */
const scrollRef = (// eslint-disable-line @typescript-eslint/explicit-module-boundary-types
node, reference) => {
    if (!reference) {
        throw new Error('scrollRef require a hash');
    }
    elementsList.push({
        node,
        reference: (0, utils_1.sanitize)(reference)
    });
    return {
        destroy() {
            elementsList.length = 0; // empty the elements list
        }
    };
};
exports.default = scrollRef;
